export const OPEN_EXISTING_PAYMENT_SIDE_PANEL = 'OPEN_EXISTING_PAYMENT_SIDE_PANEL';
export const CLOSE_EXISTING_PAYMENT_SIDE_PANEL = 'CLOSE_EXISTING_PAYMENT_SIDE_PANEL';
export const FETCH_PARTNERSHIP_PAYMENT_SUCCESS = `FETCH_PARTNERSHIP_PAYMENT/SUCCESS`;
